import React, { useEffect, useState } from "react";
import { Alert, Snackbar } from "@mui/material";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import SellingService from "../../services/SellingService";
import FactureTable from "./Table/FactureTable";
import SocieteAndUserService from '../../services/societeAndUser'
import Societe from "../../services/Societe";
import withLoader from "../../components/layouts/WithLoader";
const FactureSellEtat = ({ startLoading, stopLoading }) => {

    const [allClients, setAllClients] = useState([{ value: 0, label: "Tous" }]);
    const [showElement, setShowElement] = useState(
        JSON.parse(localStorage.getItem("status"))
    );
    const [societeLabel, setSocieteLabel] = useState([]);
    const [data, setData] = useState(null);
    const [clients, setClients] = useState([]);
    const [dateDebut, setDateDebut] = useState(null);
    const [dateFin, setDateFin] = useState(null);
    const [idClient, setIdClient] = useState(null);


    const [dateSelected, setDateSelcted] = useState(new Date().toISOString().split('T')[0]);
    const [openErrorAlert, setOpenErrorAlert] = useState(false);
    const [errorAlertText, setErrorAlertText] = useState("");
    const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
    const [display, setDisplay] = useState(false);
    const [statusFacture, setStatusFacture] = useState("1");

    const [groupes, setAllGroupes] = useState([]);


    const [successAlertText, setSuccessAlertText] = useState("");

    useEffect(() => {


        Societe.getSocietesClients("CLIENT", "CLIENT", 1, 0)
            .then((reponse) => {
                setClients(reponse.data["Societe"]);
            })
            .catch((e) => {
                setOpenErrorAlert(true);
                setErrorAlertText(
                    "Erreur : il ya un probléme pour obtenir les clients"
                );
            });

        // startLoading();

    }, []);
    useEffect(() => {
        clients &&
            clients.map((element, i) => {
                let exist = false;
                if (allClients.length !== 0) {
                    for (let index = 0; index < allClients.length; index++) {
                        if (allClients[index].value === element?.id) {
                            exist = true;
                            break;
                        }
                    }
                }

                if (element?.id !== undefined && exist === false) {
                    setAllClients((oldArray) => [
                        ...oldArray,
                        { value: element.id, label: element.title },
                    ]);
                }
            });
    }, [clients]);
    useEffect(() => {
        SocieteAndUserService.getListGroupsByIdUser(getCurrentUserId()).then((response) => {
            console.log(response)
            const grp = response.data.success.map(item => ({
                value: item.id,
                label: item.title.trim(),
            }))
            setAllGroupes(grp)
        }).catch((e) => {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : " + e);
        })
    }, []);
    const handleMultiSelectChange = (selectedOptions) => {
        setSocieteLabel(selectedOptions);
        setIdClient(selectedOptions.value)
        console.log("Selected commerciaux:", selectedOptions);
    };

    const handleSuccessClose = (event, reason) => {
        if (reason !== "clickaway") {
            setOpenSuccessAlert(false);
        }
    };

    const handleErrorClose = (event, reason) => {
        if (reason !== "clickaway") {
            setOpenErrorAlert(false);
        }
    };

    const onConfirmAddSocieteHandler = async () => {
        try {
            // Start loading
            startLoading();
            console.log("idClient",idClient);

            // Validate required fields
            if (!dateDebut) {
                setErrorAlertText("La date de début est requise !");
                setOpenErrorAlert(true);
                return;
            }

            if (!dateFin) {
                setErrorAlertText("La date de fin est requise !");
                setOpenErrorAlert(true);
                return;
            }

            if (idClient===null) {
                setErrorAlertText("Le client est requis !");
                setOpenErrorAlert(true);
                return;
            }

            if (!statusFacture) {
                setErrorAlertText("Le statut de la facture est requis !");
                setOpenErrorAlert(true);
                return;
            }

            // Format dates to the required format
            const formattedDateDebut = `${dateDebut}T00:00:00`;
            const formattedDateFin = `${dateFin}T23:59:59`;

            // Prepare the data object
            const data = {
                dateDebut: formattedDateDebut,
                dateFin: formattedDateFin,
                idClient: idClient,
                idUser: getCurrentUserId(), // Assuming getCurrentUserId() always returns a valid ID
                payed: Number(statusFacture),
            };

            // Call the API
            const response = await SellingService.getFactureClientByGroup(data);
            setData(response.data);
        } catch (error) {
            console.error("Erreur lors de l'ajout de la facture :", error);
            setErrorAlertText("Échec de l'ajout de la facture. Veuillez réessayer.");
            setOpenErrorAlert(true);
        } finally {
            // Stop loading
            stopLoading();
        }
    };




    return (
        <div className="content-wrapper" style={{ marginTop: "0" }}>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-6"></div>
                        <div className="col-md-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">Home</li>
                                <li className="breadcrumb-item ">Les factures de vente</li>
                                <li className="breadcrumb-item active">Etat</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-dark">
                                <div className="card-header">
                                    <h5 className="card-title">État des factures de vente</h5>
                                </div>
                                <div className="card-body">
                                    <div className="row" style={{ marginTop: 10 }}>
                                        {!showElement?.includes("USER_B2B") && (
                                            <>
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Date Debut:</label>
                                                        <input
                                                            className="form-control"
                                                            type="date"
                                                            value={dateDebut}
                                                            onChange={(e) => setDateDebut(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Date Fin:</label>
                                                        <input
                                                            className="form-control"
                                                            type="date"
                                                            value={dateFin}
                                                            onChange={(e) => setDateFin(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label for="groupe-select"> Choisir le Client:</label>
                                                        <Select
                                                            options={allClients}
                                                            value={societeLabel}
                                                            onChange={handleMultiSelectChange}
                                                            className="basic-multi-select"
                                                            classNamePrefix="select"
                                                        />
                                                    </div>
                                                </div>

                                                {/* Payée or Non Payée radio buttons */}
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Status de Facture:</label><br />
                                                        <label>
                                                            <input
                                                                type="radio"
                                                                name="statusFacture"
                                                                value="1"
                                                                checked={statusFacture === "1"}
                                                                onChange={(e) => setStatusFacture(e.target.value)}
                                                            />

                                                            <span className="ml-1">Payée</span>
                                                        </label>
                                                        <label style={{ marginLeft: 20 }}>
                                                            <input
                                                                type="radio"
                                                                name="statusFacture"
                                                                value="0"
                                                                checked={statusFacture === "0"}
                                                                onChange={(e) => setStatusFacture(e.target.value)}
                                                            />
                                                            <span className="ml-1">Non Payée</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <button
                                        className="btn btn-dark float-right"
                                        onClick={onConfirmAddSocieteHandler}
                                    >
                                        Confirmer
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {data && typeof data === 'object' && Object.keys(data).length > 0 && <FactureTable date={dateSelected} data={data} statusFacture={statusFacture} />}
            <Snackbar
                open={openSuccessAlert}
                autoHideDuration={2000}
                onClose={handleSuccessClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert variant="filled" onClose={handleSuccessClose} severity="success">
                    {successAlertText}
                </Alert>
            </Snackbar>
            <Snackbar
                open={openErrorAlert}
                autoHideDuration={2000}
                onClose={handleErrorClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert variant="filled" onClose={handleErrorClose} severity="error">
                    {errorAlertText}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default withLoader(FactureSellEtat);
